import api from "./client"

/** Login — stores access + refresh tokens in localStorage. */
export async function login(username: string, password: string): Promise<void> {
  const response = await api.post("auth/login/", { username, password })
  localStorage.setItem("access",  response.data.access)
  localStorage.setItem("refresh", response.data.refresh)
}

/** Clear stored tokens (call on logout or 401 that can't be refreshed). */
export function logout(): void {
  localStorage.removeItem("access")
  localStorage.removeItem("refresh")
}

/** Returns true when an access token is present in storage. */
export function isAuthenticated(): boolean {
  return !!localStorage.getItem("access")
}

/**
 * Attempt a silent token refresh using the stored refresh token.
 * Returns true on success, false if the refresh token is missing or rejected.
 */
export async function refreshAccessToken(): Promise<boolean> {
  const refresh = localStorage.getItem("refresh")
  if (!refresh) return false
  try {
    const response = await api.post("auth/token/refresh/", { refresh })
    localStorage.setItem("access", response.data.access)
    if (response.data.refresh) localStorage.setItem("refresh", response.data.refresh)
    return true
  } catch {
    logout()
    return false
  }
}
